/* Nutravel cart drawer: adds a rewards bar, a savings note, a "Complete your ritual" upsell row,
   trust points and a total on the checkout button to the Shiprocket mini cart.
   The cart comes from the 'nv:cart' event fired by nv-cart-feedback.js after every cart change. */
(function () {
  var drawer = document.getElementById('mini-cart-darwer');
  if (!drawer) return;

  // Automatic offers, matching Shopify admin → Discounts (amounts in paise). Update here if they change.
  var TIERS = [
    { at: 35000, label: 'free delivery', short: 'Free delivery' },
    { at: 49800, label: '10% off', short: '10% off' },
    { at: 74700, label: '20% off', short: '20% off' }
  ];
  var MAX = TIERS[TIERS.length - 1].at;

  // What to suggest, by what is already in the bag (product handles)
  var H = {
    hairKit: 'hibinut-hair-ritual-kit-hair-oil-herbal-shampoo',
    trio: 'daily-wellness-trio-ashwagandha-giloy-moringa-capsules',
    hibinut: 'hibinut-ayurvedic-hair-oil-hair-fall-growth-30ml',
    shampoo: 'shampoo',
    kumkumadi: 'nutravel-kumkumadi-face-oil-15ml-ayurvedic-radiance-glowing-skin-nourishing-face-oil',
    beard: 'nutravel-beard-oil-ayurvedic-beard-growth-nourishment-grooming-oil',
    faceWash: 'face-wash',
    bodyWash: 'body-wash',
    baloka: 'baloka-ayurvedic-onion-hair-oil-100-ml',
    triphalaRas: 'triphala-ras',
    ashwagandha: 'nutravel-ashwagandha-capsules-500-mg-supports-overall-wellness-vitality-60-capsules-d-pack-of-1',
    shilajit: 'nutravel-shilajit-capsules-500-mg-60-capsules-supports-strength-and-stamina',
    moringa: 'nutravel-moringo-capsules-60-capsules-500-mg-rich-in-natural-vitamins-minerals-antioxidants-plant-protein-healthy-fats'
  };
  var PAIRS = {
    hair: [H.hairKit, H.shampoo, H.kumkumadi, H.beard, H.baloka],
    skin: [H.faceWash, H.kumkumadi, H.bodyWash, H.hairKit, H.shampoo],
    beard: [H.faceWash, H.shampoo, H.hairKit, H.bodyWash],
    wellness: [H.trio, H.triphalaRas, H.ashwagandha, H.shilajit, H.moringa],
    start: [H.hairKit, H.trio, H.kumkumadi, H.beard, H.shampoo, H.hibinut]
  };
  function groupOf(handle) {
    if (/beard/.test(handle)) return 'beard';
    if (/hair|shampoo|baloka|jatta|hibinut/.test(handle)) return 'hair';
    if (/kumkumadi|face|body-wash|hand-wash/.test(handle)) return 'skin';
    return 'wellness';
  }

  function inr(p) { return '₹' + (p / 100).toFixed(2).replace(/\.00$/, ''); }
  function shortName(t) {
    return String(t || '').trim().split(/\s[–|-]\s|\s\|\s|:\s/)[0].replace(/^Nutravel\s+/i, '').replace(/\s*·\s*60 caps$/i, '').trim();
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  // ---------- product data (cached for the session) ----------
  var mem = {};
  function product(handle) {
    if (mem[handle]) return mem[handle];
    var key = 'nvd-p-' + handle, hit = null;
    try { hit = JSON.parse(sessionStorage.getItem(key)); } catch (e) {}
    mem[handle] = hit ? Promise.resolve(hit) : fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var v = (p.variants || []).find(function (x) { return x.available; }) || p.variants[0];
        var slim = { handle: p.handle, title: p.title, url: '/products/' + p.handle, img: p.featured_image, price: v.price,
          compare: v.compare_at_price, id: v.id, available: p.available };
        try { sessionStorage.setItem(key, JSON.stringify(slim)); } catch (e) {}
        return slim;
      }).catch(function () { return null; });
    return mem[handle];
  }

  // ---------- build the extra blocks once ----------
  var body = drawer.querySelector('.mini-cart-body');
  var itemsBox = drawer.querySelector('#mini-cart-items-container');
  var footer = drawer.querySelector('.mini-cart-footer');
  var emptyBox = drawer.querySelector('.mini-cart-empty-cart');

  var rewards = el('div', 'nvd-rewards');
  rewards.setAttribute('aria-live', 'polite');
  var msg = el('p', 'nvd-rewards__msg');
  var track = el('div', 'nvd-rewards__track');
  var fill = el('div', 'nvd-rewards__fill');
  track.appendChild(fill);
  var marks = TIERS.map(function (t) {
    var m = el('div', 'nvd-ms', '<i></i><span><b>' + inr(t.at) + '</b>' + t.short + '</span>');
    m.style.left = (t.at / MAX * 100) + '%';
    track.appendChild(m);
    return m;
  });
  rewards.appendChild(msg); rewards.appendChild(track);
  if (body) body.insertBefore(rewards, body.firstChild);

  var save = el('p', 'nvd-save'); save.hidden = true;
  var up = el('section', 'nvd-up'); up.setAttribute('aria-label', 'Complete your ritual'); up.hidden = true;
  up.innerHTML = '<div class="nvd-up__head"><h3 class="nvd-up__title">Complete your ritual</h3>' +
    '<div class="nvd-up__nav"><button type="button" aria-label="Previous" data-d="-1">‹</button><button type="button" aria-label="Next" data-d="1">›</button></div></div>' +
    '<div class="nvd-up__row"></div>';
  var row = up.querySelector('.nvd-up__row');
  up.querySelectorAll('.nvd-up__nav button').forEach(function (b) {
    b.addEventListener('click', function () { row.scrollBy({ left: Number(b.dataset.d) * 162, behavior: 'smooth' }); });
  });
  if (itemsBox) { itemsBox.parentNode.insertBefore(save, itemsBox.nextSibling); save.parentNode.insertBefore(up, save.nextSibling); }

  var trust = el('ul', 'nvd-trust',
    '<li><svg viewBox="0 0 24 24"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/></svg>Cash on delivery</li>' +
    '<li><svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>Secure checkout</li>' +
    '<li><svg viewBox="0 0 24 24"><path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>Made in Panchkula</li>');
  if (footer) footer.insertBefore(trust, footer.firstChild);

  var emptyUp = el('div', 'nvd-up nvd-empty-up'); emptyUp.hidden = true;
  emptyUp.innerHTML = '<div class="nvd-up__head"><h3 class="nvd-up__title">Start with a bestseller</h3></div><div class="nvd-up__row"></div>';
  if (emptyBox) emptyBox.appendChild(emptyUp);

  // ---------- render ----------
  var cart = null, wasOn = [];
  function base(c) { return c.original_total_price || c.items_subtotal_price || 0; }

  function renderRewards(c) {
    var b = base(c);
    fill.style.width = Math.min(100, b / MAX * 100) + '%';
    var next = TIERS.find(function (t) { return b < t.at; });
    if (!c.item_count) msg.innerHTML = 'Free delivery over <b>' + inr(TIERS[0].at) + '</b> · up to <b>20% off</b> automatically';
    else if (next) msg.innerHTML = 'Add <b>' + inr(next.at - b) + '</b> more for <b>' + next.label + '</b>';
    else msg.innerHTML = '🎉 You’ve unlocked <b>20% off</b> and <b>free delivery</b>';
    marks.forEach(function (m, i) {
      var on = b >= TIERS[i].at;
      m.classList.toggle('is-on', on);
      if (on && wasOn[i] === false) { m.classList.add('is-new'); setTimeout(function () { m.classList.remove('is-new'); }, 800); }
      wasOn[i] = on;
    });
  }

  function renderSave(c) {
    var off = Math.max(0, base(c) - c.total_price);
    save.hidden = !off;
    if (off) save.innerHTML = 'You’re saving <b>' + inr(off) + '</b> on this order';
  }

  function card(p, unlock) {
    var c = el('article', 'nvd-card' + (unlock ? ' is-unlock' : ''));
    c.innerHTML = (unlock ? '<span class="nvd-card__tag">Unlocks ' + unlock + '</span>' : '') +
      '<a class="nvd-card__img" href="' + p.url + '"><img loading="lazy" alt="" src="' + p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=320"></a>' +
      '<div class="nvd-card__body"><a class="nvd-card__name" href="' + p.url + '">' + shortName(p.title) + '</a>' +
      '<span class="nvd-card__price">' + inr(p.price) + (p.compare > p.price ? '<s>' + inr(p.compare) + '</s>' : '') + '</span>' +
      '<button type="button" class="nvd-card__add" aria-label="Add ' + shortName(p.title).replace(/"/g, '') + ' to bag">+ Add</button></div>';
    var btn = c.querySelector('.nvd-card__add');
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: p.id, quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return window.updateMiniCartSection && window.updateMiniCartSection(); })
        .then(function () { btn.removeAttribute('aria-busy'); btn.classList.add('is-done'); btn.textContent = 'Added ✓'; })
        .catch(function () { btn.removeAttribute('aria-busy'); btn.textContent = 'Try again'; });
    });
    return c;
  }

  var upToken = 0;
  function renderUpsell(c) {
    var token = ++upToken;
    var inCart = {}; (c.items || []).forEach(function (i) { inCart[i.handle] = true; });
    var list = [];
    if (c.item_count) {
      var counts = {};
      c.items.forEach(function (i) { var g = groupOf(i.handle); counts[g] = (counts[g] || 0) + i.quantity; });
      var main = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
      list = PAIRS[main].concat(PAIRS.start);
    } else list = PAIRS.start;
    list = list.filter(function (h, i) { return list.indexOf(h) === i && !inCart[h]; }).slice(0, 8);

    var b = base(c);
    var next = c.item_count ? TIERS.find(function (t) { return b < t.at; }) : null;
    var gap = next ? next.at - b : 0;  // amount to the next reward

    Promise.all(list.map(product)).then(function (ps) {
      if (token !== upToken) return;
      ps = ps.filter(function (p) { return p && p.available; });
      // tag a card with the best reward it would unlock on its own (e.g. "Unlocks 20% off")
      var tagged = ps.map(function (p, i) {
        var best = '';
        if (gap) TIERS.forEach(function (t) { if (b < t.at && b + p.price >= t.at) best = t.short; });
        return { p: p, i: i, unlock: best, rank: best ? TIERS.findIndex(function (t) { return t.short === best; }) : -1 };
      });
      tagged.sort(function (x, y) {
        if (!!x.unlock !== !!y.unlock) return x.unlock ? -1 : 1;
        if (x.unlock && x.rank !== y.rank) return y.rank - x.rank;
        if (x.unlock) return x.p.price - y.p.price;
        return x.i - y.i;
      });
      var target = c.item_count ? up : emptyUp;
      var r = target.querySelector('.nvd-up__row');
      r.innerHTML = '';
      tagged.slice(0, 6).forEach(function (t) { r.appendChild(card(t.p, t.unlock)); });
      up.hidden = !c.item_count || !tagged.length;
      emptyUp.hidden = !!c.item_count || !tagged.length;
    });
  }

  function renderCheckout(c) {
    var btn = drawer.querySelector('#sr-buy-now-button');
    if (!btn || !c.item_count) return;
    var text = 'Place order · ' + inr(c.total_price);
    if (btn.textContent.trim() !== text) btn.textContent = text;
  }

  function shortTitles() {
    drawer.querySelectorAll('#mini-cart-items .mini-cart-item-title').forEach(function (t) {
      var s = shortName(t.textContent);
      if (s && t.textContent.trim() !== s) t.textContent = s;
    });
  }

  function render(c) {
    cart = c;
    renderRewards(c); renderSave(c); renderUpsell(c); renderCheckout(c); shortTitles();
  }

  document.addEventListener('nv:cart', function (e) { render(e.detail); });

  // Shiprocket re-renders the item list and the button: re-apply short titles and the total
  var items = drawer.querySelector('#mini-cart-items');
  if (items && window.MutationObserver) {
    new MutationObserver(function () { shortTitles(); if (cart) renderCheckout(cart); }).observe(items, { childList: true });
  }
  var buyBtn = drawer.querySelector('#sr-buy-now-button');
  if (buyBtn && window.MutationObserver) {
    new MutationObserver(function () { if (cart) renderCheckout(cart); }).observe(buyBtn, { childList: true, characterData: true, subtree: true });
  }
})();
